import { render, staticRenderFns } from "./ViewPatientShow.vue?vue&type=template&id=58e874b8&"
import script from "./ViewPatientShow.vue?vue&type=script&lang=js&"
export * from "./ViewPatientShow.vue?vue&type=script&lang=js&"
import style0 from "./ViewPatientShow.vue?vue&type=style&index=0&id=58e874b8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports